import { Col, ColProps } from 'antd';
import styled from 'styled-components';

export const LeftMenu = styled(Col).attrs<ColProps>({
  xxl: 4,
  xl: 5,
  lg: 5,
})`
  background: var(--coolest-gray-10);
  border-right: solid 1px var(--border-color);
  height: 100vh;
  padding: var(--layout-03);
  display: flex;
  flex-direction: column;

  h5 {
    margin-bottom: var(--layout-03);
  }
`;
